export default __webpack_public_path__ + "static/media/contact.0a9c58a2.jpg";